// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"92eaed31c63c5a8088cf","655":"2489a9c17410f8429852"}[chunkId] + ".js";
};